import {
  content,
  editable,
  h1TagEnabled,
  text,
  textBoxWidth,
  //  ETextCopyTrigger,
} from '@/src/tools/contentModulesFieldName';
import { EPreviewSize } from '@/src/types/common/SalesChannel';
import { CONTENT, moduleStyleFields } from 'src/strategies/render/constant';
import i18n from '../i18n';
import { ResponsiveContainer, ResponsiveField } from '../util';
import { MOUDLE_STYLE, TEXT } from './constant';
import {
  getModuleStyleTemplate,
  moduleStyle_not_editable,
} from './imageCarousel';
import { EnumModuleType } from '@/src/types/common/module';

export default (values: any, responsiveType: EPreviewSize) => {
  const moduleStyleSetting = getModuleStyleTemplate(
    values,
    responsiveType,
    EnumModuleType.ResponsiveText,
  );
  return [
    {
      id: TEXT,
      titleHide: true,
      field: [
        {
          field: ResponsiveField.H1Tag,
          disabled: responsiveType !== EPreviewSize.WIDE,
        },
      ],
      fields: [[h1TagEnabled]],
    },
    {
      title: i18n['general.content.moduleStyle'],
      id: MOUDLE_STYLE,
      type: ResponsiveContainer.ModuleStyle,
      field: moduleStyleSetting,
      fields: moduleStyleFields,
    },
    {
      title: i18n['general.content.content'],
      onTextCopyEventPath: `${content}.${text}`,
      id: CONTENT,
      field: [
        {
          field: ResponsiveField.RichText,
          disabled: !(
            responsiveType === EPreviewSize.WIDE ||
            values[`${CONTENT}_${editable}`]
          ),
        },
      ],
      fields: [
        [content, text],
        [content, textBoxWidth],
      ],
    },
  ];
};

export const not_editable = [...moduleStyle_not_editable];
